import { config } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default defineNuxtPlugin(nuxtApp => {
  // This is important, we are going to let Nuxt worry about the CSS
  config.autoAddCss = false
  nuxtApp.vueApp.component('font-awesome-icon', FontAwesomeIcon)
})
